export default __webpack_public_path__ + "static/media/icon_under.a3fb5630.svg";